import OpportunitiesMineralsSlider from '../../opportunities/OpportunitiesMineralsSlider'
import FutureMineralsCountriesOpportunitiesGrid from '../../opportunities/FutureMineralsCountriesOpportunitiesGrid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GrInProgress } from 'react-icons/gr'
import { Link } from 'react-router-dom'

export default function FutureMineralsCountriesOpportunitiesContainer({ country, lng }) {
  const { t } = useTranslation()
  const [opportunitiesCount, setOpportunitiesCount] = useState(0)

  if (!country.opportunities || country.opportunities.length == 0)
    return (
      <div className="mt-8">
        <h2 className="mb-4 text-3xl font-black">{country[`name_${lng}`]}</h2>
        <div className={`border-muted-300 col-span-12 flex h-[256px] items-center justify-center border-2 bg-light p-8`}>
          <div className={`flex flex-col items-center space-y-6`}>
            <GrInProgress size={40} />
            <h2 className={`text-xl font-bold`}>{t('DATA_LOADING_IN_PROGRESS')}</h2>
          </div>
        </div>
      </div>
    )
  else
    return (
      <div className="mt-8">
        <div className="mb-4">
          <h2
            data-aos-delay="300"
            data-aos="fade-up"
            className="mb-4 text-3xl font-black"
          >
            {country[`name_${lng}`]}
          </h2>
          <OpportunitiesMineralsSlider minerals={country.minerals} />
          <div
            data-aos-delay="300"
            data-aos="fade-up"
            className="flex items-center gap-4 sm:items-end"
          >
            <span className="bg-primary-600 inline-block select-none px-6 py-1 text-8xl font-bold text-white">{opportunitiesCount}</span>
            <h3 className="text-secondary-600 text-4xl font-black leading-relaxed">{t('INVESTMENT_OPPORTUNITIES_CURRENTLY_AVAILABLE')}</h3>
          </div>
        </div>
        <FutureMineralsCountriesOpportunitiesGrid
          opportunities={country.opportunities}
          onChangeCount={(count) => setOpportunitiesCount(count)}
        />
        {country.source && (
          <div className="mt-16">
            <h4 className="mb-1 font-bold">{t('SOURCE')}</h4>
            <Link
              target="_blank"
              className="hover:text-secondary-600 underline"
              to={country.source.link}
            >
              {country.source[`source_${lng}`]}
            </Link>
          </div>
        )}
      </div>
    )
}
